import React, { Component } from 'react'
import { event } from '../analytics'

import i18n from '../../i18n'
import TitleSection from './TitleSection'
import StepsByDocs from '../Steps/StepsByDocs'

class Docs extends Component {
  constructor(props) {
    super(props)
  }

  isIBJJF() {
    if (i18n.language === 'en') return true
    false
  }

  isFirstMembership() {
    return this.props.choosedOptions.membershipType === 'first'
  }

  infositesDBUrl() {
    let baseUrl = `${App.INFOSITE_APP_URL}/${
      this.isIBJJF() ? 'en-US' : 'pt-BR'
    }`

    if (this.isFirstMembership()) return `${baseUrl}/auth/create`

    return `${baseUrl}/auth/login`
  }

  render() {
    const { currency, fee, ageOnYear } = this.props

    return (
      <React.Fragment>
        <TitleSection
          title={i18n.t('membership.docs.title')}
          subtitle=""
          subtitleInfo={i18n.t('membership.docs.subtitleInfo')}
        />

        <section className="row">
          <div className="col-sm-12">
            <div className="register-now text-center mb-4">
              <a
                href={this.infositesDBUrl()}
                className="btn btn-warning"
                target="_blank"
                onClick={() =>
                  event('Membership', 'Membership fill form clicked')
                }
              >
                {i18n.t('membership.docs.startOnlineApplication')}
              </a>
            </div>
          </div>
        </section>

        <StepsByDocs
          type={'membership'}
          currency={currency}
          fee={fee}
          docs={this.props.docs}
        />

        {/* Display no physical card message for juvenile/adults */}
        {ageOnYear >= 16 && (
          <div className="row text-center">
            <div className="col-sm-12 mt-4">
              <p className="text-muted">
                {i18n.t('membership.docs.physicalCardMessage')}
              </p>
            </div>
          </div>
        )}
      </React.Fragment>
    )
  }
}

export default Docs
